import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Menu } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import { Patient } from "../../models/patient";
import PatientExportsMenuDownload from "./PatientExportsMenuDownload";
import PatientExportsMenuDelete from "./PatientExportsMenuDelete";

interface PatientExportsMenuProps {
  patient: Patient;
  id: string;
  date: string;
}

export const PatientExportsMenu: React.FC<PatientExportsMenuProps> = ({
  patient,
  id,
  date,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label={String(t("patient.more-tooltip"))}
      >
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        MenuListProps={{ dense: true }}
        slotProps={{ paper: { sx: { minWidth: 180 } } }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <PatientExportsMenuDownload
          patient={patient}
          exportId={id}
          onClose={handleClose}
        />
        <PatientExportsMenuDelete
          exportId={id}
          date={date}
          onClose={handleClose}
        />
      </Menu>
    </>
  );
};

export default PatientExportsMenu;
